module.exports = __webpack_public_path__ + "assets/icons/ic_keyboard_arrow_left-1f66.svg";